<template>
    <img v-if="url" :alt="`${alt}`" :src="`${url}`" />
</template>
<script setup lang="ts">
defineProps({
    url: String,
    alt: {
        type: String,
        default: ""
    }
});
</script>
